import React, { useEffect, useState } from 'react';
import { TrendingUp } from 'lucide-react';
import { inv } from '../../lib/invApi';

const PATTERN = { steady: ['Steady', 'text-emerald-300 border-emerald-700'], occasional: ['Occasional', 'text-[#A3A3A3] border-[#3f3f3f]'], one_off: ['One-off stocking?', 'text-amber-300 border-amber-700'] };
const monthLabel = (k) => new Date(`${k}-15T12:00:00`).toLocaleDateString('en-US', { month: 'short', year: '2-digit' });
const num = (n) => (Number.isInteger(n) ? n : Number(n || 0).toFixed(1));

// Van Demand Trends — top materials pulled into vans per ET month. A hint, not usage.
export const VanDemandTrends = ({ vanId }) => {
  const [months, setMonths] = useState(6);
  const [data, setData] = useState(null);
  useEffect(() => { inv.get('/van-transfers/trends', { location_id: vanId || undefined, months }).then(({ data }) => setData(data)).catch(() => setData(null)); }, [vanId, months]);
  return (
    <section data-testid="inv-vt-trends" className="space-y-2">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h3 className="text-white text-sm uppercase tracking-wider flex items-center gap-2"><TrendingUp className="w-4 h-4 text-[#D4AF37]" /> Van Demand Trends <span className="normal-case tracking-normal text-[#525252] text-xs">month over month, Eastern Time · a hint, not confirmed usage</span></h3>
        <select data-testid="inv-vt-trend-months" value={months} onChange={(e) => setMonths(Number(e.target.value))} className="h-8 rounded-md bg-[#0A0A0A] border border-[#262626] text-white text-xs px-2">
          {[3, 6, 12].map((m) => <option key={m} value={m}>{`Last ${m} months`}</option>)}
        </select>
      </div>
      <div className="bg-[#141414] border border-[#262626] rounded-md overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead><tr className="text-[#A3A3A3] border-b border-[#262626] bg-[#0A0A0A]">
            <th className="px-3 py-2 text-left font-medium sticky left-0 bg-[#0A0A0A]">Item</th>
            {(data?.months || []).map((m) => <th key={m} className="px-3 py-2 text-right font-medium whitespace-nowrap">{monthLabel(m)}</th>)}
            <th className="px-3 py-2 text-right font-medium">Total</th><th className="px-3 py-2 text-left font-medium">Pattern</th>
          </tr></thead>
          <tbody>
            {!data || data.items.length === 0 ? <tr><td colSpan={12} className="px-3 py-6 text-center text-[#525252]">No transfers into vans in this window.</td></tr> : data.items.map((r) => (
              <tr key={r.item_id} data-testid={`inv-vt-trend-row-${r.item_id}`} className="border-b border-[#262626] last:border-0">
                <td className="px-3 py-2 text-white sticky left-0 bg-[#141414] max-w-[260px] truncate">{r.item_name}</td>
                {data.months.map((m) => <td key={m} className={`px-3 py-2 text-right ${r.by_month[m] ? 'text-white' : 'text-[#3f3f3f]'}`}>{r.by_month[m] ? num(r.by_month[m]) : '·'}</td>)}
                <td className="px-3 py-2 text-right text-[#D4AF37] font-semibold">{num(r.total)}</td>
                <td className="px-3 py-2"><span data-testid={`inv-vt-trend-pattern-${r.item_id}`} className={`text-[10px] px-2 py-0.5 rounded-full border ${PATTERN[r.pattern][1]}`}>{PATTERN[r.pattern][0]}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default VanDemandTrends;
